<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6></v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field name="code" label="Code" type="text" v-model="queryParams.code"></v-text-field>
            </v-flex>
            <v-flex sm4 v-if="this.user.role.roleName != 'BRANCH_ADMIN'">
              <shop-autocomplete
                :param="Number(queryParams.shopId)"
                @set="setShop"
              />
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="balanceSheetList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                >
                <template slot="items" slot-scope="props">
                    <td>
                      <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn flat icon color="blue lighten-2" @click="print(props.item.id)">
                        <v-icon>print</v-icon>
                      </v-btn>
                      <v-btn flat icon color="blue lighten-2" @click="exportDetailBalanceSheet(props.item.id)">
                        <v-icon>description</v-icon>
                      </v-btn>
                    </td>
                    <td>{{ props.item.code }}</td>
                    <td>{{ props.item.shop.code }}</td>
                    <td>{{ props.item.year }}</td>
                    <td>{{ props.item.month }}</td>
                    <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time }}</td>
                    <td>{{ props.item.createdBy }}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- BS print hidden area -->
    <div id="balanceSheetPrint" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center;padding-bottom:5px">
        <p
          style="font-size:15px;margin:0px;font-weight:bold;"
          v-if="balanceSheet.shop"
        >{{ balanceSheet.shop.name }}</p>
      </div>

      <div style="text-align:center">
        <p
          style="font-size:15px;margin:0px"
        >Statement Of Financial Position</p>
      </div>
      <div style="float:left;padding-left:11px">
        <p style="font-size:15px;margin:0px" id="counter">Balance Sheet Code : {{balanceSheet.code}}</p>
      </div>
      <div style="float:right;padding-right:11px">
        <p style="font-size:15px;margin:0px" id="counter"></p>
      </div>
      <br />
      <div style="float:left;padding-left:11px">
        <p
          style="font-size:15px;margin:0px"
          id="counter"
          v-if="balanceSheet.shop"
        >Shop Code: {{ balanceSheet.shop.code }}</p>
      </div>
      <div style="float:right;padding-right:11px">
        <p
          style="font-size:15px;margin:0px"
          id="counter"
        >Created Date : {{ balanceSheet.createdDateInMilliSeconds | format-ms-date }}</p>
      </div>
      <br />
      <div style="float:left;padding-left:11px">
        <p style="font-size:15px;margin:0px" id="casher">Date : {{ balanceSheet.year }}, {{ balanceSheet.month }}</p>
      </div>
      <div style="float:right;padding-right:11px">
        <p style="font-size:15px;margin:0px" id="counter">Created By : {{balanceSheet.createdBy}}</p>
      </div>
      <br />

      <div style="clear:both"></div>
      <div style="height:10px"></div>
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr style="line-height: 20px;">
              <th style="border:1px solid black;text-align:center">Account Code</th>
              <th style="border:1px solid black;text-align:center">Account Name</th>
              <th style="border:1px solid black;text-align:center">SubAccount Amount</th>
              <th style="border:1px solid black;text-align:center">Amount</th>
              <th style="border:1px solid black;text-align:center">Total Amount</th>
            </tr>
          </thead>
          <!-- start non current asset -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >NON CURRENT ASSET</td>
          </tr>
          <tbody v-for="(item, index) in balanceSheet.balanceSheetAccountList" :key="'a'+index">
             <tbody  v-if="item.sessionName == 'NON_CURRENT_ASSET'">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.netBookValue | decFormat(6)}})</span>
                <span v-else>{{item.netBookValue | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr  v-for="(itemdetail, i) in item.balanceSheetDetailList" :key="'ad'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.nature == itemdetail.nature">{{itemdetail.amount | decFormat(6)}}</span>
                <span v-else>({{itemdetail.amount | decFormat(6)}})</span>
                </td>
                <td style="border:1px solid black;text-align:center"></td>
                <td style="border:1px solid black;text-align:center"></td>
            </tr>
             </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Non Current Assets</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.nonCurrentAssetAmount | decFormat(6)}}</td>
          </tr>
          <!-- end non current asset -->
          <!-- start current asset -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >CURRENT ASSET</td>
          </tr>
          <tbody v-for="(item, index) in balanceSheet.balanceSheetAccountList" :key="'b'+index">
            <tbody v-if="item.sessionName == 'CURRENT_ASSET'">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.netBookValue | decFormat(6)}})</span>
                <span v-else>{{item.netBookValue | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr  v-for="(itemdetail, i) in item.balanceSheetDetailList" :key="'bd'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.nature == itemdetail.nature">{{itemdetail.amount | decFormat(6)}}</span>
                <span v-else>({{itemdetail.amount | decFormat(6)}})</span>
                </td>
                <td style="border:1px solid black;text-align:center"></td>
                <td style="border:1px solid black;text-align:center"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Current Assets</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.currentAssetAmount | decFormat(6)}}</td>
          </tr>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Assets</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.currentAssetAmount+balanceSheet.nonCurrentAssetAmount | decFormat(6)}}</td>
          </tr>
          <!-- end current asset -->
          <!-- start equity -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >EQUITY</td>
          </tr>
          <tbody v-for="(item, index) in balanceSheet.balanceSheetAccountList" :key="'i'+index">
            <tbody v-if="item.sessionName == 'EQUITY'">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.netBookValue | decFormat(6)}})</span>
                <span v-else>{{item.netBookValue | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr  v-for="(itemdetail, i) in item.balanceSheetDetailList" :key="'id'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.nature == itemdetail.nature">{{itemdetail.amount | decFormat(6)}}</span>
                <span v-else>({{itemdetail.amount | decFormat(6)}})</span>
                </td>
                <td style="border:1px solid black;text-align:center"></td>
                <td style="border:1px solid black;text-align:center"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Equity</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.equityAmount | decFormat(6)}}</td>
          </tr>
          <!-- end equity -->
          <!-- start current liabilities -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >CURRENT LIABILITIES</td>
          </tr>
          <tbody v-for="(item, index) in balanceSheet.balanceSheetAccountList" :key="'c'+index">
            <tbody v-if="item.sessionName == 'CURRENT_LIABILITIES'">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountCode}}</span>
              </td>
               <td style="border:1px solid black;text-align:left">
                <span>{{item.accountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.netBookValue | decFormat(6)}})</span>
                <span v-else>{{item.netBookValue | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr  v-for="(itemdetail, i) in item.balanceSheetDetailList" :key="'cd'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.nature == itemdetail.nature">{{itemdetail.amount | decFormat(6)}}</span>
                <span v-else>({{itemdetail.amount | decFormat(6)}})</span>
                </td>
                <td style="border:1px solid black;text-align:right"></td>
                <td style="border:1px solid black;text-align:right"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Current Liabilities</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.currentLiabilitiesAmount | decFormat(6)}}</td>
          </tr>
          <!-- end current liabilities -->
          <!-- start non current liabilities -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >NON CURRENT LIABILITIES</td>
          </tr>
          <tbody v-for="(item, index) in balanceSheet.balanceSheetAccountList" :key="'d'+index">
            <tbody v-if="item.sessionName == 'NON_CURRENT_LIABILITIES'">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.netBookValue | decFormat(6)}})</span>
                <span v-else>{{item.netBookValue | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr  v-for="(itemdetail, i) in item.balanceSheetDetailList" :key="'dd'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.nature == itemdetail.nature">{{itemdetail.amount | decFormat(6)}}</span>
                <span v-else>({{itemdetail.amount | decFormat(6)}})</span>
                </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:center"></td>  
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Non-Current Liabilities</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.nonCurrentLiabilitiesAmount | decFormat(6)}}</td>
          </tr>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Liabilities And Equity</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.liaEquaAmount | decFormat(6)}}</td>
          </tr>
          <!-- end non current liabilities -->
        </table>
        <div style="height:10px"></div>
      </div>
    </div>

    <!-- End print  -->
  </v-container>
</template>
<script>
import ShopAutocomplete from "../templates/ShopAutocomplete.vue";
import { balanceSheetService } from "../../services/balance-sheet-service";
import { BalanceSheet } from "../../models/model";
import { commonService } from "../../services/common-service";
export default {
  name: "BalanceSheetList",
  components: { ShopAutocomplete },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Balance Sheet",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", align: "left", sortable: false },
      { text: "Balance Sheet Code", align: "left", value: "code" },
      { text: "Shop Code", value: "shopCode" },
      { text: "Year", value: "year" },
      { text: "Month", value: "month" },
      { text: "Created Date", value: "createdDate" },
      { text: "Created By", value: "createdBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    decimalFormat: "",
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    balanceSheetList: [],
    totalRows: 0,

    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      code: "",
      shopId: "",
    },
    balanceSheet: new BalanceSheet(),
  }),
  watch: {
    pagination: {
      handler() {
        this.getBalanceSheetList();
      },
      deep: true,
    },
  },

  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      if (this.user.role.roleName == "BRANCH_ADMIN") {
        this.queryParams.shopId = this.user.shopId;
      }
      this.$router.replace({
        name: "balance-sheets",
        query: this.queryParams,
      });
      this.getBalanceSheetList();
    },
    setShop(obj) {
      this.queryParams.shopId = obj.shopId;
    },
    getBalanceSheetList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      balanceSheetService
        .getBalanceSheetList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.balanceSheetList = res.data.balanceSheetList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    exportDetailBalanceSheet(id) {
      balanceSheetService.getExportBalanceSheetDetail(id).then((res) => {
        commonService.downloadE(res);
      });
    },
    onRegister() {
      this.$router.push("/balance-sheet/new");
    },
    onEdit(balanceSheet) {
      // go to details page
      this.$router.push("/balance-sheet/" + balanceSheet.id);
    },
    print(id) {
      balanceSheetService
        .getBalanceSheetById(id)
        .then((res) => {
          this.balanceSheet = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printInvoice("balanceSheetPrint");
        });
    },
    printInvoice(divName) {
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();
    },
  },
};
</script>